import { ReactNode } from "react";
import Header from "./ProtectedHeader";
import Footer from "./Footer";
import ScrollToTop from "../common/ScrollToTop";

interface ProtectedLayoutProps {
  children: ReactNode;
}

export default function ProtectedLayout({ children }: ProtectedLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="grid flex-1">
        <ScrollToTop />
        {children}
      </main>
      <Footer />
    </div>
  );
}